<template lang="pug">
include /@ibkr/lib.common/src/icon/messaging
include /@ibkr/lib.common/src/icon/basic
ib-col(class="xl3 l3 bg spaced")
    div(class="popScanners")
        h3(class="outset-16") {{ $t('popular_bond_scanners') }}
        ul
            li(v-for="scanner in scanners", :key="scanner.id", class="inset-16 pointer fg-accent",
                :class="{ 'border-top border-bottom bg10-accent': scanner.id === selected }",
                @click="setScanner(scanner)")
                span
                    +icon-messaging-online
                span(class="outsetx-8") {{ scanner.name }}
        ul(class="searchList")
            li(v-for="search in searches" :key="searches.id" class="inset-16 fg-accent",
                :class="{ 'border-top border-bottom bg10-accent': search.id === selected }",
                @click="setCommonScans(search.id)")
                span(v-if="search.id == 10")
                    +icon-basic-search
                span(v-if="search.id == 0")
                    +icon-messaging-online
                a(class="outsetx-8 fg-accent", href="#") {{ search.name }}
        <!--hr

        ul(class="openAccount")
            li Want to save your scanners?
            li
                a(href="#") Open an Account-->
</template>

<script>
    import { scanners } from '../js/popularScanners'

    export default {
        name: 'PopularScanners',
        data() {
            return {
                scanners: scanners,
                selected: 10,
                searches: [
                    { id: 10, name: "Bond Scanner"},
                    //{id: 11, name: "Search Bonds"},
                ],
            }
        },
        methods: {
            setCommonScans(id) {
                this.selected = id;
                if(this.selected === 10) {
                    this.$emit('commonSearch');
                }
            },
            setScanner(scanner) {
                this.selected = scanner.id;
                this.$emit('setFilters', JSON.parse(JSON.stringify(scanner)));
            }
        }
    }
</script>

<style lang="less">
.popScanners {
    ul {
        padding-left: 0;
        list-style-type: none;
        width: 100%;
    }
    li {
        a {
            &:hover, &:focus {
                text-decoration: none !important;
            }
        }
    }
}

</style>
